import { useParams, useLocation, Link, useNavigate } from 'react-router-dom';
import ImportResults from '../components/ImportResults';
import type { ImportedArtefact } from '../components/ImportResults';

interface LocationState {
  importResults?: ImportedArtefact[];
}

export default function ImportPage() {
  // Sprint A.9 — parent route :projectId; alias preserves `id`.
  const { projectId: id } = useParams<{ projectId: string }>();
  const location = useLocation();
  const navigate = useNavigate();
  const state = location.state as LocationState | null;
  const results = state?.importResults;

  if (!results || results.length === 0) {
    return (
      <div className="flex-1 px-8 py-6">
        <div className="max-w-2xl">
          <Link to={`/projects/${id}`} className="text-sm text-[#2E75B6] hover:underline">
            ← Back to Project
          </Link>
          <div className="mt-8 text-center py-16 bg-white rounded-lg border border-gray-200">
            <div className="text-4xl mb-4">📂</div>
            <p className="text-gray-500 mb-4">No import results available.</p>
            <Link
              to={`/projects/${id}`}
              className="text-sm text-[#2E75B6] hover:underline"
            >
              Go back to project
            </Link>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="flex-1 overflow-auto">
      <div className="px-8 py-5 bg-white border-b border-gray-200">
        <Link to={`/projects/${id}`} className="text-sm text-gray-500 hover:text-[#2E75B6] transition-colors">
          ← Back to Project
        </Link>
        <h1 className="text-2xl font-bold text-[#111827] mt-2">Import Results</h1>
        <p className="text-sm text-gray-500 mt-1">Review and classify your imported documents</p>
      </div>

      <div className="px-8 py-6 max-w-4xl">
        <ImportResults
          results={results}
          projectId={id!}
          onAnalyseComplete={reportId => navigate(`/artefacts/${reportId}`)}
        />
      </div>
    </div>
  );
}
